import { isInUIC } from './common';

export const CAS_DOC_LINK = {
  about: 'https://docs.trendmicro.com/LANG/enterprise/cas/about_requirements',
  init_config: 'https://docs.trendmicro.com/LANG/enterprise/cas/init_config',
  provision: {
    exchangeInline: {
      learnMore:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/inline_learn_more',
      instruction:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_inline',
      failTroubleshooting:
        'http://docs.trendmicro.com/LANG/enterprise/cas/provision_online_help',
    },
    gmailInline: {
      instruction:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/gmail_inline_olh',
    },
    teamsChat: {
      note: 'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_teams_chat',
      instruction:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/teams_chat_instruction',
    },
    sharePoint: {
      userConfiguration:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_sharepoint_graph',
    },
    oneDrive: {
      userConfiguration:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_onedrive_graph',
    },
    teams: {
      userConfiguration:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_teams',
    },
    mip: {
      instruction: 'https://docs.trendmicro.com/LANG/enterprise/cas/dlp_mip',
    },
    box: {
      instruction:
        'https://docs.trendmicro.com/LANG/enterprise/cas/provision_box',
    },
  },
  deprovision: {
    contact: 'https://success.trendmicro.com/contact-support',
  },
  onlineHelpMenu: {
    whatCanIDoHere: 'https://docs.trendmicro.com/LANG/enterprise/cas/dbd',
    controlDashboardData:
      'https://docs.trendmicro.com/LANG/enterprise/cas/dbd_cdb',
    viewSummaryWidgets:
      'http://docs.trendmicro.com/LANG/enterprise/cas/dbd_wg_sw',
    viewATPWidgets: 'http://docs.trendmicro.com/LANG/enterprise/cas/dbd_wg_atp',
    viewDLPWidgets: 'http://docs.trendmicro.com/LANG/enterprise/cas/dbd_wg_dlp',
    aboutDashboard: 'http://docs.trendmicro.com/LANG/enterprise/cas/dbd_ov',
    aboutWidgets: 'http://docs.trendmicro.com/LANG/enterprise/cas/dbd_wg',
    provisionO365:
      'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_o365',
    provisionMip:
      'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_mip',
    provisionStorage:
      'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_storage',
    addRmsAccount: 'http://docs.trendmicro.com/LANG/enterprise/caso365/rms_add',
    provisionSalesforce:
      'http://docs.trendmicro.com/LANG/enterprise/cas/provision_salesforce',
    provisionGmail:
      'http://docs.trendmicro.com/LANG/enterprise/caso365/provision_gmail',
    whatsNew: 'http://docs.trendmicro.com/LANG/enterprise/cas/what_is_new',
    knownIssues: 'http://docs.trendmicro.com/LANG/enterprise/cas/ki',
    faq: 'http://docs.trendmicro.com/LANG/enterprise/cas/faq',
    about: 'http://docs.trendmicro.com/LANG/enterprise/cas/about',
  },
  policy: {
    atp: {
      va: 'http://docs.trendmicro.com/LANG/enterprise/cas/atp_ap_va',
      tokenList: 'https://docs.trendmicro.com/LANG/enterprise/caso365/atp_tl',
      advancedSpamProtection:
        'https://docs.trendmicro.com/LANG/enterprise/cas/atp_ap_as',
      unusualSignal:
        'http://docs.trendmicro.com/LANG/enterprise/cas/unusual_signal',
      predictiveMachineLearning:
        'http://docs.trendmicro.com/LANG/enterprise/cas/predictive_machine_learning',
    },
    dlp: {},
  },
  globalSetting: {},
  dashboard: {
    preRelease: 'https://docs.trendmicro.com/LANG/enterprise/cas/pre-release',
    protectionFeatureAdoption:
      'https://docs.trendmicro.com/LANG/enterprise/cloud-app-security-online-help/about-cloud-app-secu/about-the-new-consol/key-feature-adoption.aspx',
  },
  administrator: {
    migration: {
      spMigrate:
        'http://docs.trendmicro.com/LANG/enterprise/cas/sharepoint_online_migration',
      odMigrate:
        'http://docs.trendmicro.com/LANG/enterprise/cas/sharepoint_online_migration',
    },
    singleSignOn: {
      azureAd:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/saml_sso_azure_ad',
      adfs: 'http://docs.trendmicro.com/LANG/enterprise/caso365/saml_sso_adfs',
      okta: 'http://docs.trendmicro.com/LANG/enterprise/caso365/saml_sso_okta',
      google:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/saml_sso_google',
      pingOne:
        'http://docs.trendmicro.com/LANG/enterprise/caso365/saml_sso_pingone',
    },
    apiTokens: {
      getStart:
        'http://docs.trendmicro.com/LANG/enterprise/cas/integration-apis/getting_started.html',
      logRetrieval:
        'http://docs.trendmicro.com/LANG/enterprise/cas/integration-apis/supported_log_retrival_apis.html',
      threatInvestigation:
        'http://docs.trendmicro.com/LANG/enterprise/cas/integration-apis/supported_threat_investigation_apis.html',
      threatMitigation:
        'http://docs.trendmicro.com/LANG/enterprise/cas/integration-apis/supported_threat_mitigation_apis.html',
      threatRemediation:
        'http://docs.trendmicro.com/LANG/enterprise/cas/integration-apis/supported_threat_remediation_apis.html',
    },
    serviceAccout: {
      storageReauth: {
        instructions:
          'https://docs.trendmicro.com/LANG/enterprise/cas/ServiceAccount',
      },
    },
  },
};

export function getDocLang(lang: string) {
  switch (lang) {
    case 'en':
      return 'en-us';
    case 'ja':
      return 'ja-jp';
    case 'de':
      return 'de-de';
    default:
      return 'en-us';
  }
}
export const THIRD_PARTY_LINK = {
  howToUpdateV1InitialLicenseVideo:
    'https://app.storylane.io/share/mafahjmolhei',
  howToUpdateV1ConnectProductVideo:
    'https://app.storylane.io/share/uap1qbaoofg0',
  howToUpdateV1UpdateToProductVideo:
    'https://app.storylane.io/share/2khrrbydvru8',
  businessSuccessPortal:
    'https://success.trendmicro.com/en-US/contactus/?_ga=2.181361447.1618568817.1755123477-1602777751.1748871970',
  howToUpdateP1:
    'https://app.supademo.com/demo/cmde9un4q00g2vm0itt9ij8jc?utm_source=link&step=10',
  howToUpdateP2:
    'https://app.supademo.com/demo/cmde9un4q00g2vm0itt9ij8jc?utm_source=link&step=19',
  howToUpdateP3:
    'https://app.supademo.com/demo/cmde9un4q00g2vm0itt9ij8jc?utm_source=link&step=24',
  addInIntegratedApps:
    'https://admin.microsoft.com/Adminportal/Home?source=applauncher#/Settings/IntegratedApps',
  gmailAddInMarketplace:
    'https://workspace.google.com/marketplace/app/email_and_collaboration_security/397544213092',
  contactReseller: 'https://partner.trendmicro.com/en-US/partner-locator-home/',
  conditionalAccessAction:
    'https://learn.microsoft.com/en-us/azure/active-directory/conditional-access/concept-conditional-access-cloud-apps',
  o365AuditLogTurnOn:
    'https://learn.microsoft.com/en-us/purview/audit-log-enable-disable?tabs=microsoft-purview-portal',
  gmailComprehensiveMailStorage: 'https://support.google.com/a/answer/3547347',
};

/**
 * @example getCasOLHLink(CAS_DOC_LINK.deprovision.contact, i18next.language)
 */
export function getCasOLHLink(
  string: string,
  language: string,
  replaceFn?: (s: string, lang: string) => string
) {
  const docLang = getDocLang(language);
  const platform = isInUIC() ? 'trend-xdr' : 'new-ui';
  //default replace 'LANG'
  return replaceFn
    ? replaceFn(string, docLang)
    : string.replace(
        '/LANG/enterprise/',
        `/${docLang}/enterprise/${platform}/`
      );
}
